var _path, _path2, _ellipse, _ellipse2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 793.199,
    height: 653.806,
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M793.2 280.862c0 123.61-73.485 166.77-164.132 166.77s-164.132-43.16-164.132-166.77C464.936 157.252 629.068 0 629.068 0s164.131 157.252 164.131 280.862z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m953.382 374.329 1.359-83.66 51.628-73.717-51.415 60.562.85-153.404-5.337 203.078.439-8.377-52.492-80.347 51.65 96.429-4.891 93.434-.146-2.48-60.513-84.553 60.33 93.314-.612 11.685-.109.176.05.959-12.409 237.05h16.579l1.989-122.441 60.182-93.085-60.032 83.881 1.68-103.45 69.957-127.983-69.693 111.754.756-46.515 48.214-92.595z",
    style: {
      fill: "#320b08",
      fillOpacity: 1
    },
    transform: "translate(-327.393 -124.11)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.896,
    cy: 556.369,
    fill: "#3f3d56",
    rx: 390.896,
    ry: 28.034,
    style: {
      fill: "#320b08",
      fillOpacity: 1,
      strokeWidth: 0.839544
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 565.052,
    cy: 602.687,
    fill: "#3f3d56",
    rx: 94.989,
    ry: 4.802,
    style: {
      fill: "#320b08",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 221.327,
    cy: 649.004,
    fill: "#3f3d56",
    rx: 94.989,
    ry: 4.802,
    style: {
      fill: "#320b08",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.092,
    cy: 441.305,
    r: 79,
    fill: "#2f2e41",
    style: {
      fill: "#320b08",
      fillOpacity: 1
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m368.893 511.145 22.942-7.05 12.631 41.102-22.94 7.05zM414.775 497.049l22.941-7.05 12.632 41.102-22.941 7.05z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.461,
    cy: 640.46,
    fill: "#2f2e41",
    rx: 20,
    ry: 7.5,
    transform: "rotate(-17.083)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.461,
    cy: 639.46,
    fill: "#2f2e41",
    rx: 20,
    ry: 7.5,
    transform: "rotate(-17.083)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 381.129,
    cy: 421.6,
    r: 27,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 381.129,
    cy: 421.6,
    r: 9,
    fill: "#3f3d56",
    style: {
      fill: "#320b08",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b82f6",
    d: "M290.259 393.591c-14.49-25.433-3.479-59.016 24.594-75.01 28.072-15.992 62.576-8.34 77.065 17.094 14.49 25.433-2.39 41.643-30.463 57.636-28.073 15.993-56.707 25.713-71.196.28zM244.2 476.147c0 50.557-30.054 68.21-67.13 68.21q-1.289 0-2.573-.03c-1.718-.036-3.42-.118-5.1-.232-33.461-2.368-59.458-20.93-59.458-67.948 0-48.66 62.181-110.06 66.852-114.603l.008-.008.27-.262s67.13 64.316 67.13 114.873z",
    style: {
      fill: "#e14f45",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m174.624 536.622 24.552-34.307-24.614 38.074-.065 3.939c-1.718-.037-3.42-.119-5.1-.233l2.646-50.582-.02-.393.044-.073.25-4.777L147.64 450.1l24.753 34.586.058 1.014 2-38.217-21.125-39.44 21.382 32.732 2.082-79.233.008-.27v.262l-.347 62.48 21.03-24.77-21.116 30.152-.557 34.218 19.637-32.84-19.718 37.875-.311 19.022 28.507-45.706-28.614 52.345z",
    style: {
      fill: "#320b08",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b82f6",
    d: "M508.2 497.232c0 55.076-32.74 74.306-73.13 74.306q-1.404 0-2.803-.03c-1.872-.041-3.725-.13-5.556-.255-36.452-2.58-64.772-22.8-64.772-74.021 0-53.008 67.74-119.896 72.827-124.846l.01-.01c.195-.19.294-.284.294-.284s73.13 70.064 73.13 125.14z",
    style: {
      fill: "#e14f45",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "m432.405 563.113 26.747-37.374-26.814 41.477-.071 4.291c-1.871-.04-3.725-.13-5.556-.254l2.883-55.102-.023-.428.05-.08.271-5.205-26.88-41.58 26.965 37.677.062 1.105 2.179-41.633-23.013-42.965 23.294 35.658 2.267-86.314.01-.294v.285l-.38 68.064 22.912-26.983-23.005 32.846-.606 37.276 21.392-35.774-21.48 41.259-.34 20.723 31.056-49.792-31.171 57.023z",
    style: {
      fill: "#320b08",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -274.288,
    cy: 522.353,
    fill: "#2f2e41",
    rx: 12.4,
    ry: 39.5,
    style: {
      fill: "#320b08",
      fillOpacity: 1
    },
    transform: "rotate(-64.626)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound2);
export default __webpack_public_path__ + "static/media/not-found2.8b5b58d20a45caf0ee856e8f9a497e55.svg";
export { ForwardRef as ReactComponent };